import { MediaDetail } from '../models/EventResult';

export const defaultHTMLIframe = (content: string, color?: string) => {
  return `
        <head>
            <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;700&display=swap" rel="stylesheet">
        </head>
        <body style="font-family: Poppins, sans-serif;color: ${
          color ? color : '#3b4559'
        }">
            ${content}
        </body>
    `;
};

export const parseHTMLDescription = (
  content: string,
  color?: string,
  maxLines?: number,
) => {
  const regex = /(<([^>]+)>)/gi;
  return defaultHTMLIframe(
    `
    <p style="font-size: 1rem;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: ${maxLines};-webkit-box-orient: vertical;cursor: pointer">
        ${content.replaceAll(regex, ' ')}
    </p>
  `,
    color,
  );
};

export const getImageUrl = (mediaDetails: MediaDetail[]) => {
  let imageUrl;
  mediaDetails?.forEach((mediaDetail) => {
    if (mediaDetail.name === '1536x1536') {
      imageUrl = mediaDetail?.sourceUrl;
    } else if (mediaDetail?.name === 'medium_large') {
      imageUrl = mediaDetail?.sourceUrl;
    }
  });
  return imageUrl ?? '';
};
